<script setup lang="ts">
import type { UseFinancingData } from '~/store-v2/financings/useFinancing'
import type { UseInstallationData } from '~/store-v2/installation/useInstallation'
import { SolButton, SolEmptyState } from '@solfacil/girassol'

const props = defineProps<{
  financing: NonNullable<UseFinancingData>
  installation?: UseInstallationData | null
}>()

const router = useRouter()
const { t } = useI18n()

const projectId = computed(() => props.financing.project_id)

const emptyTitle = computed(() => t('installationPage.canceled.title'))

const emptySubtitle = computed(() => {
  const description = t('installationPage.canceled.description')

  if (props.financing.is_combo)
    return `${description} ${t('installationPage.canceled.combo_description')}`

  return description
})

function redirectFormalization() {
  if (props.financing.person_type === 'PF')
    return router.push(`/customer/${projectId.value}`)

  return router.push(`/company/${projectId.value}`)
}
</script>

<template>
  <div class="installation-page">
    <NavigationHeaderBar
      stage="installation"
      :title="installation?.project_name ?? financing.customer_name"
      :status="installation?.status?.slug"
      :financing="financing"
    />

    <div class="container">
      <div class="card-container canceled-card">
        <SolEmptyState
          id="installation-canceled"
          :title="emptyTitle"
          :subtitle="emptySubtitle"
          variant="empty-list"
          class="!max-w-full md:system:max-w-[550px]"
        />
      </div>
    </div>

    <SolButton
      id="installation-back-formalization"
      size="medium"
      class="w-full md:system:w-auto mt-6"
      variant="secondary"
      @click="redirectFormalization"
    >
      {{ t('installationPage.footer.formalization') }}
    </SolButton>
  </div>
</template>

<style scoped lang="scss">
.installation-page {
  @apply flex flex-col py-2xs px-4xs;

  @screen md:system {
    @apply px-2xs pb-sm pt-2xs;
  }
}

.container {
  @apply bg-neutral-high-pure rounded-lg p-2xs;
}

.canceled-card {
  @apply flex flex-col items-center justify-center w-full py-16;

  @screen md:system {
    @apply py-20;
  }
}
</style>
